import { ProductSource } from "@redotech/cockroachdb-codegen/tables/product/product-source";
import { productCategoryIdFormat } from "@redotech/redo-product-id";
import { assertNever } from "@redotech/util/type";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const ProductCategorySourceSchema = createEnum(ProductSource);
export type ProductCategorySource = z.infer<typeof ProductCategorySourceSchema>;

export const RawProductCategorySourceSchema = createEnum([
  "shopify",
  "bigcommerce",
  "commentsold",
  "commerce-cloud",
  "cin7-omni",
  "cin7-core",
  "amazon",
  "ebay",
]);
export type RawProductCategorySource = z.infer<
  typeof RawProductCategorySourceSchema
>;

function transformProductCategorySource(
  source: ProductCategorySource | RawProductCategorySource,
): ProductCategorySource {
  switch (source) {
    case "shopify":
      return ProductSource.Shopify;
    case "bigcommerce":
      return ProductSource.Bigcommerce;
    case "commentsold":
      return ProductSource.Commentsold;
    case "commerce-cloud":
      return ProductSource.CommerceCloud;
    case "cin7-omni":
      return ProductSource.Cin7Omni;
    case "cin7-core":
      return ProductSource.Cin7Core;
    case "amazon":
      return ProductSource.Amazon;
    case "ebay":
      return ProductSource.Ebay;
    default:
      assertNever(source);
  }
}

export function toRawProductCategorySource(
  source: ProductSource,
): RawProductCategorySource {
  switch (source) {
    case ProductSource.Shopify:
      return "shopify";
    case ProductSource.Bigcommerce:
      return "bigcommerce";
    case ProductSource.Commentsold:
      return "commentsold";
    case ProductSource.CommerceCloud:
      return "commerce-cloud";
    case ProductSource.Cin7Omni:
      return "cin7-omni";
    case ProductSource.Cin7Core:
      return "cin7-core";
    case ProductSource.Amazon:
      return "amazon";
    case ProductSource.Ebay:
      return "ebay";
    default:
      assertNever(source);
  }
}

export const ProductCategorySchema = z.object({
  id: productCategoryIdFormat.schema,
  name: z.string(),
  source: z
    .union([ProductCategorySourceSchema, RawProductCategorySourceSchema])
    .transform(transformProductCategorySource),
  sourceId: z.string(),
  parentId: productCategoryIdFormat.schema.nullable(),
});
export type ProductCategory = z.infer<typeof ProductCategorySchema>;
